import { render, staticRenderFns } from "./InviteCeremonyModal.vue?vue&type=template&id=bd43ecfe"
import script from "./InviteCeremonyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteCeremonyModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports